import React, { useContext, useEffect, useState } from "react";
import UserList from "../../components/listComponents/userList/UserList";
import { SearchBar } from "../../components";
import SortListComponent from "../../components/listComponents/sortListComponent/SortListComponent";
import { AuthContext } from "../../services/context/authContext/AuthContext";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../services/firebaseConfig";

function Users() {
  const loggedInUser = useContext(AuthContext);
  const userEmail = loggedInUser && loggedInUser.email;
  const [userListDefault, setUserListDefault] = useState([]);
  const [users, setUsers] = useState([]);
  const [sortItem, setSortItem] = useState("recent");
  const [isLoading, setIsLoading] = useState(false);
  const [input, setInput] = useState("");
  const sortList = [
    "recent",
    "A-Z",
    "accountant",
    "contractor",
    "confirmed",
    "pending",
  ];

  useEffect(() => {
    const admin = loggedInUser?.role === "admin";

    const getUsers = async () => {
      try {
        setIsLoading(true);
        const q = !admin
          ? query(collection(db, "users"), where("createdBy", "==", userEmail))
          : query(collection(db, "users"));

        const users = await getDocs(q);

        if (!users.empty) {
          const userList = [];
          users.forEach((doc) => userList.push(doc.data()));
          setUserListDefault(userList);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getUsers();
  }, [userEmail, loggedInUser?.role]);

  useEffect(() => {
    const filter = () => {
      let filteredList = [...userListDefault];
      if (sortItem === "confirmed") {
        filteredList = userListDefault.filter((user) => {
          if (!user.disabled) {
            return user;
          }
          return null;
        });
        setUsers(filteredList);
      } else if (sortItem === "pending") {
        filteredList = userListDefault.filter((user) => {
          if (user.disabled) {
            return user;
          }
          return null;
        });
        setUsers(filteredList);
      } else if (sortItem === "recent") {
        filteredList.sort((a, b) => {
          return b.createdAt.toDate() - a.createdAt.toDate();
        });
        setUsers(filteredList);
      } else if (sortItem === "A-Z") {
        filteredList.sort((a, b) => {
          return a.email.localeCompare(b.email);
        });
        setUsers(filteredList);
      } else if (sortItem === "contractor") {
        filteredList = userListDefault.filter((user) => {
          if (user.role === "contractor") {
            return user;
          }
          return null;
        });
        setUsers(filteredList);
      } else if (sortItem === "accountant") {
        filteredList = userListDefault.filter((user) => {
          if (user.role === "accountant") {
            return user;
          }
          return null;
        });
        setUsers(filteredList);
      }
    };
    return filter();
  }, [sortItem, userListDefault]);

  const updateInput = async (input) => {
    const filtered = userListDefault.filter((user) => {
      if (
        user.company.toLowerCase().includes(input.toLowerCase()) ||
        user.email.toLowerCase().includes(input.toLowerCase())
      ) {
        return user;
      }
      return null;
    });
    setInput(input);
    setUsers(filtered);
  };
  return (
    <div>
      <div className="px-5 tablet:px-16 desktop:px-20">
        <h2 className="mb-10">Users</h2>
        <SearchBar keyword={input} setKeyword={updateInput} />
        <div className="flex flex-col mx-4 tablet:mx-0  tablet:flex-row gap-5 mt-16 tablet:items-center ">
          <SortListComponent
            items={sortList}
            item={sortItem}
            setItem={setSortItem}
          />
        </div>
        <UserList users={users} isLoadingList={isLoading} />
      </div>
    </div>
  );
}

export default Users;
